module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-light-blue.9ab0654a.svg";